import { IDirective } from 'angular';
import { GmcDropdownMenuController } from '../gmc-dropdown-menu.component';

export function gmcDropdownMenuItemDirective(): IDirective {
  return {
    restrict: 'EA',
    require: '^gmcDropdownMenu',
    link: function postLink( scope, element, attr, dropDownCtrl: GmcDropdownMenuController ) {
      element.on('click', () => {
        scope.$apply(() => dropDownCtrl.toggle());
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/shared/components/gmc-dropdown-menu/directives/gmc-dropdown-menu-item.directive.ts